const env = process.env.NODE_ENV
let baseurl = '/prod/'
let publicpath = '/'
switch (env) {
  case 'development':
    baseurl = ''
    break
  default:
    baseurl = '/prod/'
}
module.exports = {
  title: '',
  baseurl: baseurl,
  publicpathurl: publicpath,
  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: true,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production',

  //报告附件大小错误提醒
  reportsizeerror: '上传文件大小不能超过200M',
  //文件大小限制
  filesizelimit: 200,
  documentsuffix: '.doc,.docx,.pdf,.xlsx,.xls,.zip,.rar',
  documenttips: '只能上传doc/docx/pdf/xls/xlsx/zip/rar文件，且不超过200M',
  documensize: 200
}
